<template>
    <div class="py-6 border-b border-grey-200">
        <div class="container flex justify-center">
            <div
                v-for="(selectField, i) in selects"
                :key="i"
                class="w-56 px-8 text-blue-500 border-grey-200"
                :class="{ 'border-l': i > 0 }"
            >
                <p class="relative ml-3 small text-grey-500">
                    {{ capitalize(selectField) }}
                    <span
                        v-if="activeFacets[selectField]"
                        class="relative z-10 px-2 ml-3 text-white bg-blue-500 rounded cursor-pointer small py-2px"
                        @click="$emit('clear-facet', selectField)"
                    >
                        Clear
                    </span>
                </p>

                <Select
                    :value="activeFacets[selectField]"
                    :options="scopedFacets[selectField]"
                    class="w-full"
                    :settings="{ label: 'label' }"
                    @input="$emit('update-facet', [selectField, $event])"
                />
            </div>

            <div class="w-56 px-8 text-blue-500 border-l border-grey-200">
                <p class="ml-3 small text-grey-500">Sort</p>

                <Select
                    :value="activeSort"
                    :options="sortOptions"
                    :settings="{ label: 'label' }"
                    class="w-full"
                    @input="$emit('update-sort', $event)"
                />
            </div>
        </div>
    </div>
</template>

<script>
import capitalize from 'lodash/capitalize';
import Select from '@/../vue/_base/form/Select';

export default {
    components: {
        Select
    },

    props: {
        selects: {
            type: Array,
            required: true
        },
        activeFacets: {
            type: Object,
            required: true
        },
        scopedFacets: {
            type: Object,
            required: true
        },
        activeSort: {
            type: String,
            default: null
        },
        sortOptions: {
            type: Array,
            required: true
        }
    },

    methods: {
        capitalize(text) {
            return capitalize(text);
        }
    }
};
</script>
